<!-- it's a public route, help section
can search about anything related to the project
In (UI) top right side-> question mark icon
-->
<template>
  <div class="w-100 h-100-vh px-2">
    <div class="main">
      <h2 class="heading">Hello, how can we help?</h2>
      <v-row no-gutters align="center" justify="center">
        <div class="container">
          <div class="text-field">
            <v-icon>mdi-magnify</v-icon>
            <input
              @keyup.enter="searchData"
              class="searchBar"
              type="text"
              v-model="searchText"
              placeholder="Ask a question..."
            />
          </div>
          <x-button
            :color="primaryColor"
            class="ml-2 button"
            @click="searchData"
            buttonText="Search"
          />
        </div>
      </v-row>
      <HelpResults :loading="loading" :textMessage="textMessage" :searchResults="searchResults"
        :pageNumber="pageNumber"
        :pageSize="pageSize"
        :searchMeta="searchMeta"
        @changePage="changePage($event)"
      />
    </div>
  </div>
</template>
<script>
import HelpResults from '@/components/HelpResults';
import search from '@/services/PublicAPIService';
import colors from '../constants/colors';
export default {
  data() {
    return {
      searchText: '',
      primaryColor: colors.primary,
      loading: false,
      searchResults: [],
      pageSize: 40,
      pageNumber: 1,
      searchMeta: { page_count: 1, total_entries: 1 },
      textMessage: '',
    };
  },
  methods: {
    /**
     * to get searched data
     * @param {Boolean} newSearch
     */
    async searchData(newSearch = true) {
      if (newSearch) {
        this.pageNumber = 1;
      }
      this.textMessage = '';
      if (!this.searchText) {
        this.searchResults = [];
        this.textMessage = '';
        return;
      }
      this.loading = true;
      try {
        this.loading = true;
        const response = await search.getSearchedData({
          text: this.searchText.replace(' ', '+') || '',
          page: this.pageNumber,
        });
        this.searchResults = response.data.results;
        if (!this.searchResults.length) {
          this.textMessage = 'No Results found !';
        } else {
          this.textMessage = '';
        }
        this.searchMeta = response.data.meta;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.snackbar('error', err);
      }
    },
    /**
     * to change page
     * @param {Number} changedPage
     */
    changePage(changedPage) {
      this.pageNumber = changedPage;
      this.searchData(false);
    },
  },
  components: {HelpResults},
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 760px;
  margin: auto;
}
.container {
  margin-top: 28px;
  display: flex;
  background-color: #e0eeee;
  border-radius: 6px;
  justify-content: space-between;
}
.text-field {
  display: flex;
  flex: 1;
}
.searchBar {
  outline: white;
}
.heading {
  padding-top: 20px;
  text-align: center;
}
</style>
